import styled from 'styled-components';

const CenterLogoutBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 40px;
`;

export { CenterLogoutBtn }

